import React from 'react'

const Home = props => {
  return (
    <div className="home">
      Home
    </div>
  )
}

export default Home


// WEBPACK FOOTER //
// ./src/components/Home.jsx